import {
  Button,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import InputField from '../elements/InputField';

const ResetPasswordForm = ({ onSubmit }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const togglePasswordVisibility = (field) => {
    if (field === 'password') {
      setShowPassword((prev) => !prev);
    } else if (field === 'passwordConfirmation') {
      setShowConfirmation((prev) => !prev);
    }
  };

  return (
    <Formik
      initialValues={{ password: '', passwordConfirmation: '' }}
      validationSchema={Yup.object().shape({
        password: Yup.string()
          .required('New Password is required')
          .min(8, 'Password must be at least 8 characters')
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
            'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
          ),
        passwordConfirmation: Yup.string()
          .required('Confirm Password is required')
          .oneOf([Yup.ref('password'), null], 'Confirm Password must match'),
      })}
      onSubmit={onSubmit}>
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputField
                label="New Password"
                fullWidth
                error={Boolean(touched.password && errors.password)}
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={values.password}
                name="password"
                onBlur={handleBlur}
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => togglePasswordVisibility('password')}
                      onMouseDown={(e) => e.preventDefault()}
                      edge="end"
                      size="large">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                placeholder="********"
              />
            </Grid>

            <Grid item xs={12}>
              <InputField
                label="Confirm Password"
                id="passwordConfirmation"
                type={showConfirmation ? 'text' : 'password'}
                value={values.passwordConfirmation}
                name="passwordConfirmation"
                fullWidth
                error={Boolean(
                  touched.passwordConfirmation && errors.passwordConfirmation
                )}
                onBlur={handleBlur}
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password confirmation visibility"
                      onClick={() =>
                        togglePasswordVisibility('passwordConfirmation')
                      }
                      onMouseDown={(e) => e.preventDefault()}
                      edge="end"
                      size="large">
                      {showConfirmation ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                placeholder="********"
              />
            </Grid>

            {errors.submit && (
              <Grid item xs={12}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Grid>
            )}

            <Grid item xs={12}>
              <Button
                disableElevation
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                color="primary">
                Submit
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ResetPasswordForm;
